











































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import pagelist from '@/components/pagelistcomponent';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import showimg from '@/components/showimg.vue';
@Component({ components: { showimg } })
export default class balancerechargeaudit extends pagelist {
    //request 请求参数
    get DealerServiceProxy() {
        return new proxy.MerchantWithdrawOrderServiceProxy();
    }
    fxarr = []; //所有分销商
    input = new proxy.MerchantWithdrawOrderPageInputDto();
    createrange = []
    auditrange = [];
    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center'
        },

        {
            title: '提现单号',
            key: 'orderNo',
            width: 200
        },
        {
            title: '商户',
            slot: 'merchantName',
        },
        {
            title: '姓名',
            slot: 'bankName'
        },
        {
            title: '提现金额',
            key: 'money'
        },
        {
            title: '申请时间',
            slot: 'creationTime'
        },
        {
            title: '状态',
            slot: 'auditStatus'
        },

        {
            title: '审核时间',
            slot: 'auditTime'
        },
        {
            title: '备注',
            key: 'comment'
        },
        //   {
        //     title: '拒绝原因',
        //     key: 'refuseReason'
        //   }
    ];
    showpic(url) {
        var showpic = this.$refs.showpic as any;
        showpic.larget(url);
    }
    exportrecord() {

    }
    FxArgeeRecharge() {
        if (this.selectedDataItems.length == 0) {
            this.$Notice.error({ title: '请至少选中一条数据' });
            return;
        }
        var ids = this.selectedDataItems.map(x => {
            return x.id;
        });
        var req = new proxy.IdsDto();
        req.idList = ids;
        //this.DealerServiceProxy.fxArgeeRecharge(req).then(() => {});
        this.DealerServiceProxy.approvd(req).then(() => {
            this.$Notice.success({ title: '审核成功' })
            this.getpage();
        });
    }
    FxNotRecharge() {
        if (this.selectedDataItems.length == 0) {
            this.$Notice.error({ title: '请至少选中一条数据' });
            return;
        }
        var ids = this.selectedDataItems.map(x => {
            return x.id;
        });
        var req = new proxy.IdsDto();
        req.idList = ids;
        this.DealerServiceProxy.notApprovd("", req).then(() => {
            this.$Notice.success({ title: '审核成功' })
            this.getpage();
        });
    }
    fetchDataList(
        request: PagedFilterAndSortedRequest,
        pageNumber: number,
        finishedCallback: Function
    ): void {
        this.input.skipCount = request.skipCount;
        this.input.maxResultCount = request.maxResultCount;
        this.input.sorting = request.sorting;
        // this.input.createStartTime = this.createrange[0];
        // this.input.createEndTime = this.createrange[1];
        // this.input.auditStartTime = this.auditrange[0];
        // this.input.auditEndTime = this.auditrange[1]
        this.DealerServiceProxy.queryModelList(this.input).then(x => {
            this.dataList = x.items;
            this.showPaging(x);
        });
    }

    getpage() {
        this.OnInit();
    }
    async created() {
        this.input.auditStatus = 0;
        this.getpage();
    }
}
